<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('SaleProductManagerSegments') + saleProductManagerName"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row mb-6" v-has-permission="permission48">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("Segment") }}</label>
            <v-select
              label="name"
              name="segment"
              v-model="segmentModel.segmentId"
              :options="segments"
              :reduce="(x) => x.id"
              ref="productSegment"
              v-validate="'required'"
              dir="rtl"
            ></v-select>
            <span class="text-danger text-sm" v-show="errors.has('segment')">{{
              errors.first("segment")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn mt-6"
              @click.prevent="assignSegment()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[{ title: $t('Segment') }, { title: $t('Action') }]"
      >
        <template slot-scope="{ row }">
          <td style="width: 76%">
            {{ row.segmentName }}
          </td>
          <td style="width: 20%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignSegment(row.segmentId)"
              class="d-inline"
              v-has-permission="permission49"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
const dict = {
  custom: {
    segment: {
      required: "لطفا سگمنت را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SaleProductManagers_SegmentsPopup",

  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },

  data() {
    return {
      permission48: "",
      permission49: "",
      gridDataSource: { data: [] },
      gridSearchData: {},
      saleProductManagerName: "",
      segmentModel: {
        saleProductManagerId: null,
        segmentId: null,
      },
      searchQueryNew: "",
      searchQueryOld: "",
      segmentsLoading: true,
      segments: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
        this.segmentModel.segmentId = "";
      },
    },
    ...mapGetters({
      allContracts: "sale/list",
    }),
  },
  methods: {
    ...mapActions({
      assignSegmentInfo: "sale/assignSegmentToSaleProductManager",
      unassignSegmentInfo: "sale/unassignSaleProductManagerSegment",
      getSegments: "productSegment/getAllSegments",
    }),
    onAgentSegmentSelected(data) {
      this.segmentModel.segmentId = data.id;
    },
    assignSegment() {
      this.segmentModel.saleProductManagerId = this.model.saleProductManagerId;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.assignSegmentInfo(this.segmentModel).then(() => {
            this.$vs.notify({
              title: "عملیات موفق",
              text: "سگمنت مورد نظر با موفقیت اضافه شد!",
              color: "success",
            });
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    unassignSegment(segmentId) {
      var saleProductManagerId = this.model.saleProductManagerId;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignSegmentInfo({ saleProductManagerId, segmentId }).then(
            () => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت حذف شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$refs.grid.renderGrid();
            }
          );
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.saleProductManagerName) {
          this.saleProductManagerName = "،" + this.model.saleProductManagerName;
        } else {
          this.saleProductManagerName = "";
        }
        this.$validator.reset();
        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SaleProductManagerQuery/" +
            this.model.saleProductManagerId +
            "/segments-info",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    DataGrid,
    vSelect,
  },
  mounted() {
    this.getSegments().then((response) => {
      this.segmentsLoading = false;
      if (!response.success) {
        this.segments = response;
      }
    });
  },
};
</script>
